import { ASSET_LABELS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/asset_labels_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { LabelEntityType } from '../types/labels';

const targetCollectionNames = [LabelEntityType.ASSET, 'assetsIndex', 'assetLabelsDropdown'];

const initialState: any = standardInitialStateGenerator(targetCollectionNames);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
